import { FileLink, SimpleFileLink } from '@texas/api/endpoints/filesApi';
import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export interface MatrixFileValue {
  matrixNodeValueXId: number;
  matrixNodeValueYId: number;
  file: SimpleFileLink | null;
}

export const fileEvents = {
  fileUploadComplete: new SimpleEventDispatcher<FileLink>(),
  fileChanged: new SimpleEventDispatcher<FileLink>(),
  matrixFileChanged: new SimpleEventDispatcher<MatrixFileValue>(),
  fileDeleted: new SignalDispatcher(),
};
